package com.patronat.top.client.presentation.home.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import com.patronat.top.client.deeplink.clientVenueDeepLink
import com.patronat.top.client.platform.shareText
import com.patronat.top.dto.VenueResponse
import com.patronat.top.dto.venues.DayOfWeek as VenueDayOfWeek
import com.patronat.top.dto.venues.VenueMediaRef
import com.patronat.top.dto.venues.WorkDay
import com.patronat.top.dto.venues.VenueStatus
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.AppNetworkImage
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.theme.AppIcons
import com.patronat.top.ui.theme.BodyMedium
import com.patronat.top.ui.theme.MineShaft100
import com.patronat.top.ui.theme.MineShaft200
import com.patronat.top.ui.theme.MineShaft400
import com.patronat.top.ui.theme.MineShaft50
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft600
import com.patronat.top.ui.theme.MineShaft700Strong
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.MineShaft950
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.StatusActiveBg
import com.patronat.top.ui.theme.White
import kotlinx.datetime.Clock
import kotlinx.datetime.LocalTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.client_home_badge_unverified
import top.clientapp.generated.resources.client_home_badge_verified
import top.clientapp.generated.resources.client_home_favorite_content_description
import top.clientapp.generated.resources.client_venue_action_catalog
import top.clientapp.generated.resources.client_venue_action_phone
import top.clientapp.generated.resources.client_venue_action_share
import top.clientapp.generated.resources.client_venue_action_website
import top.clientapp.generated.resources.client_venue_back_content_description
import top.clientapp.generated.resources.client_venue_closed
import top.clientapp.generated.resources.client_venue_description
import top.clientapp.generated.resources.client_venue_leave_review
import top.clientapp.generated.resources.client_venue_rating_atmosphere
import top.clientapp.generated.resources.client_venue_rating_personal
import top.clientapp.generated.resources.client_venue_rating_price
import top.clientapp.generated.resources.client_venue_rating_quality
import top.clientapp.generated.resources.client_venue_rating_speed
import top.clientapp.generated.resources.client_venue_reviews
import top.clientapp.generated.resources.client_venue_reviews_count
import top.clientapp.generated.resources.client_venue_reviews_view_all
import top.clientapp.generated.resources.client_venue_services_empty
import top.clientapp.generated.resources.client_venue_services_short_title
import top.clientapp.generated.resources.client_venue_status_closes_at
import top.clientapp.generated.resources.client_venue_status_open
import top.clientapp.generated.resources.client_web_profile_title

@Composable
fun VenueDetailsContent(
    venue: VenueResponse,
    isFavorite: Boolean,
    onBackClick: () -> Unit,
    onFavoriteClick: () -> Unit,
    onCatalogClick: () -> Unit,
    onViewReviewsClick: () -> Unit,
    onReviewClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val uriHandler = LocalUriHandler.current
    val gallery = remember(venue.gallery) {
        venue.gallery.filter { !it.publicUrl.isNullOrBlank() }
    }
    val pagerState = rememberPagerState(pageCount = { gallery.size.coerceAtLeast(1) })
    val scope = rememberCoroutineScope()
    var showScheduleSheet by remember { mutableStateOf(false) }

    LaunchedEffect(venue.id, gallery.size) {
        pagerState.scrollToPage(0)
    }

    Box(
        modifier = modifier
            .fillMaxSize()
            .background(White)
    ) {
        LazyColumn(
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(bottom = 92.dp)
        ) {
            item {
                VenueHeroImage(
                    gallery = gallery,
                    pagerState = pagerState,
                    title = venue.name,
                    isFavorite = isFavorite,
                    onBackClick = onBackClick,
                    onFavoriteClick = onFavoriteClick
                )
            }

            item {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 24.dp, vertical = 10.dp)
                ) {
                    VenueThumbnailRow(
                        gallery = gallery,
                        selectedIndex = pagerState.currentPage.coerceAtMost((gallery.size - 1).coerceAtLeast(0)),
                        onImageClick = { index ->
                            scope.launch {
                                pagerState.animateScrollToPage(index)
                            }
                        }
                    )

                    Spacer(modifier = Modifier.height(18.dp))

                    VenueStatusBadge(status = venue.status)

                    Spacer(modifier = Modifier.height(24.dp))

                    Text(
                        text = venue.name,
                        style = BodyMedium.copy(
                            color = MineShaft900,
                            fontSize = 28.sp,
                            lineHeight = 42.sp,
                            fontWeight = FontWeight.Medium
                        ),
                        maxLines = 2,
                        overflow = TextOverflow.Ellipsis
                    )

                    Spacer(modifier = Modifier.height(14.dp))

                    VenueAddressLine(address = venue.location.address)

                    Spacer(modifier = Modifier.height(10.dp))

                    VenueWorkStatusLine(
                        venue = venue,
                        onClick = { showScheduleSheet = true }
                    )

                    Spacer(modifier = Modifier.height(10.dp))

                    VenueRatingLine(venue = venue)

                    Spacer(modifier = Modifier.height(18.dp))

                    VenueActionRow(
                        onWebsiteClick = {
                            venue.website?.takeIf(String::isNotBlank)?.let { url ->
                                runCatching { uriHandler.openUri(url.withHttpScheme()) }
                            }
                        },
                        onPhoneClick = {
                            venue.phone.takeIf(String::isNotBlank)?.let { phone ->
                                runCatching { uriHandler.openUri("tel:${phone.filterPhoneForUri()}") }
                            }
                        },
                        onShareClick = {
                            shareText(
                                title = venue.name,
                                text = venue.shareMessage()
                            )
                        },
                        onCatalogClick = onCatalogClick
                    )

                    Spacer(modifier = Modifier.height(26.dp))

                    VenueDescriptionBlock(description = venue.description)

                    Spacer(modifier = Modifier.height(26.dp))

                    VenueReviewsBlock(
                        venue = venue,
                        onViewAllClick = onViewReviewsClick
                    )
                }
            }
        }

        AppButton(
            text = stringResource(Res.string.client_venue_leave_review),
            onClick = onReviewClick,
            type = ButtonType.Black,
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 22.dp)
        )

        if (showScheduleSheet) {
            VenueScheduleSheet(
                venue = venue,
                onDismiss = { showScheduleSheet = false }
            )
        }
    }
}

@Composable
fun VenueDetailsDesktopContent(
    venue: VenueResponse,
    isFavorite: Boolean,
    onBackClick: () -> Unit,
    onFavoriteClick: () -> Unit,
    onCatalogClick: () -> Unit,
    onViewReviewsClick: () -> Unit,
    onReviewClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val uriHandler = LocalUriHandler.current
    val gallery = remember(venue.gallery) {
        venue.gallery.filter { !it.publicUrl.isNullOrBlank() }
    }
    var selectedImageIndex by remember(venue.id) { mutableStateOf(0) }
    var showScheduleSheet by remember { mutableStateOf(false) }

    LaunchedEffect(venue.id, gallery.size) {
        selectedImageIndex = 0
    }

    Box(
        modifier = modifier
            .fillMaxSize()
            .background(White)
    ) {
        LazyColumn(
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(start = 24.dp, top = 88.dp, end = 24.dp, bottom = 24.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            item {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .widthIn(max = 1392.dp)
                ) {
                    VenueDetailsDesktopHeader(onBackClick = onBackClick)

                    Spacer(modifier = Modifier.height(20.dp))

                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .heightIn(min = 650.dp)
                            .clip(RoundedCornerShape(10.dp))
                            .border(1.dp, MineShaft100, RoundedCornerShape(10.dp))
                            .background(White)
                            .padding(24.dp),
                        horizontalArrangement = Arrangement.spacedBy(44.dp),
                        verticalAlignment = Alignment.Top
                    ) {
                        Column(
                            modifier = Modifier.width(597.dp)
                        ) {
                            VenueDesktopGallery(
                                gallery = gallery,
                                title = venue.name,
                                selectedIndex = selectedImageIndex.coerceIn(
                                    0,
                                    (gallery.size - 1).coerceAtLeast(0)
                                ),
                                onImageClick = { selectedImageIndex = it }
                            )

                            Spacer(modifier = Modifier.height(22.dp))

                            VenueDescriptionBlock(description = venue.description)
                        }

                        Column(
                            modifier = Modifier.width(328.dp)
                        ) {
                            VenueStatusBadge(status = venue.status)

                            Spacer(modifier = Modifier.height(16.dp))

                            Text(
                                text = venue.name,
                                style = BodyMedium.copy(
                                    color = MineShaft900,
                                    fontSize = 28.sp,
                                    lineHeight = 42.sp,
                                    fontWeight = FontWeight.Medium
                                ),
                                maxLines = 2,
                                overflow = TextOverflow.Ellipsis
                            )

                            Spacer(modifier = Modifier.height(8.dp))

                            VenueAddressLine(address = venue.location.address)

                            Spacer(modifier = Modifier.height(10.dp))

                            VenueWorkStatusLine(
                                venue = venue,
                                onClick = { showScheduleSheet = true }
                            )

                            Spacer(modifier = Modifier.height(10.dp))

                            VenueRatingLine(venue = venue)

                            Spacer(modifier = Modifier.height(18.dp))

                            VenueActionRow(
                                onWebsiteClick = {
                                    venue.website?.takeIf(String::isNotBlank)?.let { url ->
                                        runCatching { uriHandler.openUri(url.withHttpScheme()) }
                                    }
                                },
                                onPhoneClick = {
                                    venue.phone.takeIf(String::isNotBlank)?.let { phone ->
                                        runCatching { uriHandler.openUri("tel:${phone.filterPhoneForUri()}") }
                                    }
                                },
                                onShareClick = {
                                    shareText(
                                        title = venue.name,
                                        text = venue.shareMessage()
                                    )
                                },
                                onCatalogClick = onCatalogClick
                            )

                            Spacer(modifier = Modifier.height(28.dp))

                            VenueReviewsBlock(
                                venue = venue,
                                onViewAllClick = onViewReviewsClick
                            )

                            Spacer(modifier = Modifier.height(20.dp))

                            AppButton(
                                text = stringResource(Res.string.client_venue_leave_review),
                                onClick = onReviewClick,
                                type = ButtonType.Black,
                                modifier = Modifier.fillMaxWidth()
                            )
                        }

                        VenueDesktopServicesBlock(
                            venue = venue,
                            isFavorite = isFavorite,
                            onFavoriteClick = onFavoriteClick,
                            modifier = Modifier.weight(1f)
                        )
                    }
                }
            }
        }

        if (showScheduleSheet) {
            VenueScheduleSheet(
                venue = venue,
                onDismiss = { showScheduleSheet = false }
            )
        }
    }
}

@Composable
private fun VenueDetailsDesktopHeader(
    onBackClick: () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(10.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(38.dp)
                .clip(RoundedCornerShape(12.dp))
                .clickable(onClick = onBackClick),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = AppIcons.ArrowLeft,
                contentDescription = stringResource(Res.string.client_venue_back_content_description),
                tint = MineShaft950,
                modifier = Modifier.size(26.dp)
            )
        }

        Text(
            text = stringResource(Res.string.client_web_profile_title),
            style = BodyMedium.copy(
                color = MineShaft900,
                fontSize = 28.sp,
                lineHeight = 42.sp,
                fontWeight = FontWeight.Medium
            )
        )
    }
}

@Composable
private fun VenueDesktopGallery(
    gallery: List<VenueMediaRef>,
    title: String,
    selectedIndex: Int,
    onImageClick: (Int) -> Unit
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(403.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        VenueDesktopImage(
            imageUrl = gallery.getOrNull(selectedIndex)?.publicUrl,
            title = title,
            modifier = Modifier
                .width(461.dp)
                .height(403.dp)
        )

        Column(
            modifier = Modifier
                .width(124.dp)
                .height(403.dp),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            gallery.take(3).forEachIndexed { index, media ->
                VenueDesktopImage(
                    imageUrl = media.publicUrl,
                    title = title,
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(123.67.dp)
                        .clickable { onImageClick(index) }
                )
            }
        }
    }
}

@Composable
private fun VenueDesktopImage(
    imageUrl: String?,
    title: String,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(9.dp))
            .background(MineShaft50),
        contentAlignment = Alignment.Center
    ) {
        if (imageUrl.isNullOrBlank()) {
            Icon(
                painter = AppIcons.VenueImagePlaceholder,
                contentDescription = null,
                tint = Color.Unspecified,
                modifier = Modifier.size(61.dp)
            )
        } else {
            AppNetworkImage(
                model = imageUrl,
                contentDescription = title,
                contentScale = ContentScale.Crop,
                modifier = Modifier.fillMaxSize()
            )
        }
    }
}

@Composable
private fun VenueDesktopServicesBlock(
    venue: VenueResponse,
    isFavorite: Boolean,
    onFavoriteClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Column(modifier = modifier) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = stringResource(Res.string.client_venue_services_short_title),
                style = BodyMedium.copy(
                    color = MineShaft900,
                    fontSize = 16.sp,
                    lineHeight = 24.sp,
                    fontWeight = FontWeight.Medium
                )
            )

            Box(
                modifier = Modifier
                    .size(40.dp)
                    .clip(CircleShape)
                    .clickable(onClick = onFavoriteClick),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = if (isFavorite) AppIcons.HeartFilled else AppIcons.Heart,
                    contentDescription = stringResource(Res.string.client_home_favorite_content_description),
                    tint = Color.Unspecified,
                    modifier = Modifier.size(27.dp)
                )
            }
        }

        Spacer(modifier = Modifier.height(14.dp))

        val services = venue.services.servicesList.take(5)
        if (services.isEmpty()) {
            Text(
                text = stringResource(Res.string.client_venue_services_empty),
                style = BodyMedium.copy(
                    color = MineShaft500,
                    fontSize = 15.sp,
                    lineHeight = 22.sp,
                    fontWeight = FontWeight.Normal
                )
            )
        } else {
            services.forEach { service ->
                VenueDesktopServiceRow(label = service.name)
            }
        }
    }
}

@Composable
private fun VenueDesktopServiceRow(label: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 14.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.Top
    ) {
        Box(
            modifier = Modifier
                .padding(top = 2.dp)
                .size(20.dp)
                .clip(CircleShape)
                .background(MineShaft900),
            contentAlignment = Alignment.Center
        ) {
            Box(
                modifier = Modifier
                    .size(7.dp)
                    .clip(CircleShape)
                    .background(White)
            )
        }

        Text(
            text = label,
            style = BodyMedium.copy(
                color = MineShaft600,
                fontSize = 15.sp,
                lineHeight = 24.sp,
                fontWeight = FontWeight.Normal
            ),
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1f)
        )
    }
}

@Composable
private fun VenueHeroImage(
    gallery: List<VenueMediaRef>,
    pagerState: androidx.compose.foundation.pager.PagerState,
    title: String,
    isFavorite: Boolean,
    onBackClick: () -> Unit,
    onFavoriteClick: () -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(271.dp)
            .background(MineShaft50)
    ) {
        HorizontalPager(
            state = pagerState,
            modifier = Modifier.fillMaxSize(),
            userScrollEnabled = gallery.isNotEmpty()
        ) { page ->
            val imageUrl = gallery.getOrNull(page)?.publicUrl
            if (imageUrl.isNullOrBlank()) {
                Box(
                    modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = AppIcons.VenueImagePlaceholder,
                        contentDescription = null,
                        tint = Color.Unspecified,
                        modifier = Modifier.size(72.dp)
                    )
                }
            } else {
                AppNetworkImage(
                    model = imageUrl,
                    contentDescription = title,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxSize()
                )
            }
        }

        Box(
            modifier = Modifier
                .align(Alignment.TopStart)
                .padding(start = 24.dp, top = 38.dp)
                .size(36.dp)
                .clip(CircleShape)
                .clickable(onClick = onBackClick),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = AppIcons.ArrowLeft,
                contentDescription = stringResource(Res.string.client_venue_back_content_description),
                tint = White,
                modifier = Modifier.size(24.dp)
            )
        }

        Box(
            modifier = Modifier
                .align(Alignment.TopEnd)
                .padding(end = 24.dp, top = 38.dp)
                .size(38.dp)
                .clip(CircleShape)
                .background(White)
                .clickable(onClick = onFavoriteClick),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = if (isFavorite) AppIcons.HeartFilled else AppIcons.Heart,
                contentDescription = stringResource(Res.string.client_home_favorite_content_description),
                tint = Color.Unspecified,
                modifier = Modifier.size(24.dp)
            )
        }
    }
}

@Composable
private fun VenueThumbnailRow(
    gallery: List<VenueMediaRef>,
    selectedIndex: Int,
    onImageClick: (Int) -> Unit
) {
    if (gallery.isEmpty()) return

    LazyRow(
        modifier = Modifier
            .fillMaxWidth()
            .height(59.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        itemsIndexed(gallery) { index, media ->
            val selected = index == selectedIndex
            Box(
                modifier = Modifier
                    .width(55.8.dp)
                    .height(59.dp)
                    .clip(RoundedCornerShape(9.dp))
                    .background(MineShaft50)
                    .border(
                        width = if (selected) 2.dp else 0.dp,
                        color = if (selected) ActiveStatusColor else Color.Transparent,
                        shape = RoundedCornerShape(9.dp)
                    )
                    .clickable {
                        onImageClick(index)
                    }
            ) {
                AppNetworkImage(
                    model = media.publicUrl,
                    contentDescription = null,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier
                        .fillMaxSize()
                        .padding(if (selected) 2.dp else 0.dp)
                        .clip(RoundedCornerShape(if (selected) 7.dp else 9.dp))
                )
            }
        }
    }
}

@Composable
private fun VenueStatusBadge(
    status: VenueStatus,
    modifier: Modifier = Modifier
) {
    val verified = status == VenueStatus.CONNECTED

    Row(
        modifier = modifier
            .width(228.dp)
            .height(26.dp)
            .clip(RoundedCornerShape(10.dp))
            .background(White)
            .border(0.73.dp, if (verified) OwnerAuthorizedColor else OwnerUnauthorizedColor, RoundedCornerShape(10.dp))
            .padding(horizontal = 16.dp, vertical = 4.dp),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(6.dp)
                .clip(CircleShape)
                .background(if (verified) OwnerAuthorizedColor else OwnerUnauthorizedColor)
        )

        Text(
            text = stringResource(
                if (verified) {
                    Res.string.client_home_badge_verified
                } else {
                    Res.string.client_home_badge_unverified
                }
            ),
            style = BodyMedium.copy(
                color = if (verified) OwnerAuthorizedColor else OwnerUnauthorizedColor,
                fontSize = 13.sp,
                lineHeight = 18.sp,
                fontWeight = FontWeight.Medium,
                letterSpacing = (-0.15).sp
            ),
            maxLines = 1
        )
    }
}

@Composable
private fun VenueAddressLine(address: String) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = AppIcons.VenueLocation,
            contentDescription = null,
            tint = MineShaft500,
            modifier = Modifier.size(16.dp)
        )

        Text(
            text = address,
            style = BodyMedium.copy(
                color = MineShaft600,
                fontSize = 14.sp,
                lineHeight = 24.sp,
                fontWeight = FontWeight.Normal
            ),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun VenueWorkStatusLine(
    venue: VenueResponse,
    onClick: () -> Unit
) {
    val status = remember(venue.schedule) { venue.currentWorkStatus() }

    Row(
        modifier = Modifier.clickable(onClick = onClick),
        horizontalArrangement = Arrangement.spacedBy(6.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(14.dp)
                .clip(CircleShape)
                .border(1.dp, if (status.isOpen) ActiveStatusColor else MineShaft500, CircleShape),
            contentAlignment = Alignment.Center
        ) {
            Box(
                modifier = Modifier
                    .size(4.dp)
                    .clip(CircleShape)
                    .background(if (status.isOpen) ActiveStatusColor else MineShaft500)
            )
        }

        Text(
            text = if (status.isOpen) {
                stringResource(Res.string.client_venue_status_open)
            } else {
                stringResource(Res.string.client_venue_closed)
            },
            style = BodyMedium.copy(
                color = if (status.isOpen) ActiveStatusColor else MineShaft600,
                fontSize = 14.sp,
                lineHeight = 21.sp,
                fontWeight = FontWeight.Medium
            )
        )

        val secondaryTime = if (status.isOpen) status.closeTime else status.nextOpenTime
        if (secondaryTime != null) {
            Text(
                text = "•",
                style = BodyMedium.copy(color = MineShaft400, fontSize = 14.sp, lineHeight = 21.sp)
            )

            Text(
                text = if (status.isOpen) {
                    stringResource(Res.string.client_venue_status_closes_at, secondaryTime.formatTime())
                } else {
                    "Відкривається о ${secondaryTime.formatTime()}"
                },
                style = BodyMedium.copy(
                    color = MineShaft400,
                    fontSize = 14.sp,
                    lineHeight = 21.sp,
                    fontWeight = FontWeight.Medium,
                    textAlign = TextAlign.Center,
                    textDecoration = TextDecoration.Underline
                )
            )
        }
    }
}

@Composable
private fun VenueRatingLine(venue: VenueResponse) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(4.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = AppIcons.RatingStarFilled,
            contentDescription = null,
            tint = Color.Unspecified,
            modifier = Modifier.size(16.dp)
        )

        Text(
            text = venue.ratingSummaryText(),
            style = BodyMedium.copy(
                color = MineShaft600,
                fontSize = 13.sp,
                lineHeight = 18.sp,
                fontWeight = FontWeight.Normal
            )
        )
    }
}

@Composable
private fun VenueActionRow(
    onWebsiteClick: () -> Unit,
    onPhoneClick: () -> Unit,
    onShareClick: () -> Unit,
    onCatalogClick: () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(11.dp)
    ) {
        VenueActionTile(
            icon = AppIcons.ClientActionWebsite,
            label = stringResource(Res.string.client_venue_action_website),
            onClick = onWebsiteClick,
            modifier = Modifier.weight(1f)
        )
        VenueActionTile(
            icon = AppIcons.ClientActionPhone,
            label = stringResource(Res.string.client_venue_action_phone),
            onClick = onPhoneClick,
            modifier = Modifier.weight(1f)
        )
        VenueActionTile(
            icon = AppIcons.ClientActionShare,
            label = stringResource(Res.string.client_venue_action_share),
            onClick = onShareClick,
            modifier = Modifier.weight(1f)
        )
        VenueActionTile(
            icon = AppIcons.ClientActionCatalog,
            label = stringResource(Res.string.client_venue_action_catalog),
            onClick = onCatalogClick,
            modifier = Modifier.weight(1f)
        )
    }
}

@Composable
private fun VenueActionTile(
    icon: Painter,
    label: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    Column(
        modifier = modifier
            .height(73.dp)
            .clip(RoundedCornerShape(10.dp))
            .background(MineShaft50)
            .clickable(onClick = onClick)
            .padding(vertical = 9.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Icon(
            painter = icon,
            contentDescription = label,
            tint = MineShaft950,
            modifier = Modifier.size(24.dp)
        )

        Spacer(modifier = Modifier.height(7.dp))

        Text(
            text = label,
            style = BodyMedium.copy(
                color = MineShaft950,
                fontSize = 12.sp,
                lineHeight = 16.sp,
                fontWeight = FontWeight.Normal,
                textAlign = TextAlign.Center
            ),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun VenueDescriptionBlock(description: String?) {
    Text(
        text = stringResource(Res.string.client_venue_description),
        style = BodyMedium.copy(
            color = MineShaft950,
            fontSize = 16.sp,
            lineHeight = 24.sp,
            fontWeight = FontWeight.Medium
        )
    )

    Spacer(modifier = Modifier.height(14.dp))

    Text(
        text = description.orEmpty(),
        style = BodyMedium.copy(
            color = MineShaft600,
            fontSize = 15.sp,
            lineHeight = 25.6.sp,
            fontWeight = FontWeight.Normal
        )
    )
}

@Composable
private fun VenueReviewsBlock(
    venue: VenueResponse,
    onViewAllClick: () -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = stringResource(Res.string.client_venue_reviews),
            style = BodyMedium.copy(
                color = MineShaft950,
                fontSize = 16.sp,
                lineHeight = 24.sp,
                fontWeight = FontWeight.Medium
            )
        )

        Text(
            text = stringResource(Res.string.client_venue_reviews_view_all),
            style = BodyMedium.copy(
                color = MineShaft500,
                fontSize = 16.sp,
                lineHeight = 24.sp,
                fontWeight = FontWeight.Medium
            ),
            modifier = Modifier.clickable(onClick = onViewAllClick)
        )
    }

    Spacer(modifier = Modifier.height(16.dp))

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(9.dp))
            .background(MineShaft50)
            .padding(horizontal = 16.dp, vertical = 24.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier.width(82.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Text(
                text = venue.averageRatingText(),
                style = BodyMedium.copy(
                    color = MineShaft950,
                    fontSize = 48.sp,
                    lineHeight = 48.sp,
                    fontWeight = FontWeight.Normal,
                    textAlign = TextAlign.Center
                )
            )

            Text(
                text = stringResource(
                    Res.string.client_venue_reviews_count,
                    venue.reviewsCount.compactCountText()
                ),
                style = BodyMedium.copy(
                    color = MineShaft500,
                    fontSize = 12.sp,
                    lineHeight = 16.sp,
                    fontWeight = FontWeight.Normal,
                    textAlign = TextAlign.Center
                ),
                maxLines = 1
            )
        }

        Spacer(modifier = Modifier.width(16.dp))

        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(7.dp)
        ) {
            RatingMetricRow(label = stringResource(Res.string.client_venue_rating_price), progress = 0.95f)
            RatingMetricRow(label = stringResource(Res.string.client_venue_rating_quality), progress = 0.95f)
            RatingMetricRow(label = stringResource(Res.string.client_venue_rating_speed), progress = 0.86f)
            RatingMetricRow(label = stringResource(Res.string.client_venue_rating_personal), progress = 0.92f)
            RatingMetricRow(label = stringResource(Res.string.client_venue_rating_atmosphere), progress = 0.88f)
        }
    }
}

@Composable
private fun RatingMetricRow(
    label: String,
    progress: Float
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = label,
            style = BodyMedium.copy(
                color = MineShaft500,
                fontSize = 13.sp,
                lineHeight = 21.sp,
                fontWeight = FontWeight.Normal,
                textAlign = TextAlign.Center
            ),
            modifier = Modifier.width(84.dp),
            maxLines = 1,
            softWrap = false,
            overflow = TextOverflow.Clip
        )

        Box(
            modifier = Modifier
                .weight(1f)
                .height(5.dp)
                .clip(RoundedCornerShape(3.dp))
                .background(MineShaft200)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth(progress)
                    .height(5.dp)
                    .clip(RoundedCornerShape(3.dp))
                    .background(Primary600.copy(alpha = 0.72f))
            )
        }
    }
}

@Composable
private fun VenueScheduleSheet(
    venue: VenueResponse,
    onDismiss: () -> Unit
) {
    val currentDay = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date.dayOfWeek.toVenueDayOfWeek()
    val status = remember(venue.schedule) { venue.currentWorkStatus() }
    val workDays = remember(venue.schedule) {
        venue.schedule.workDays.sortedBy { it.day.sortIndex() }
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .zIndex(2f)
    ) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color.Black.copy(alpha = 0.28f))
                .clickable(onClick = onDismiss)
        )

        Column(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .fillMaxWidth()
                .clip(RoundedCornerShape(topStart = 16.dp, topEnd = 16.dp))
                .background(White)
                .clickable(onClick = {})
                .padding(horizontal = 24.dp, vertical = 24.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "Години роботи",
                    style = BodyMedium.copy(
                        color = MineShaft900,
                        fontSize = 20.sp,
                        lineHeight = 30.sp,
                        fontWeight = FontWeight.Medium,
                        letterSpacing = (-0.45).sp
                    )
                )

                Box(
                    modifier = Modifier
                        .size(32.dp)
                        .clip(CircleShape)
                        .clickable(onClick = onDismiss),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = AppIcons.Close,
                        contentDescription = null,
                        tint = MineShaft400,
                        modifier = Modifier.size(18.dp)
                    )
                }
            }

            Spacer(modifier = Modifier.height(20.dp))

            workDays.forEach { workDay ->
                VenueScheduleDayRow(
                    workDay = workDay,
                    isToday = workDay.day == currentDay
                )
            }

            Spacer(modifier = Modifier.height(18.dp))

            VenueScheduleCurrentStatus(status = status)
        }
    }
}

@Composable
private fun VenueScheduleDayRow(
    workDay: WorkDay,
    isToday: Boolean
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(46.47.dp)
            .clip(RoundedCornerShape(12.dp))
            .background(if (isToday) StatusActiveBg else Color.Transparent)
            .padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = workDay.day.label(),
            style = BodyMedium.copy(
                color = if (isToday) MineShaft950 else MineShaft500,
                fontSize = 15.sp,
                lineHeight = 22.5.sp,
                fontWeight = if (isToday) FontWeight.Medium else FontWeight.Normal,
                letterSpacing = (-0.23).sp
            ),
            modifier = Modifier.weight(1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        Text(
            text = workDay.scheduleText(),
            style = BodyMedium.copy(
                color = if (isToday) ActiveStatusColor else MineShaft950,
                fontSize = 15.sp,
                lineHeight = 22.5.sp,
                fontWeight = if (isToday) FontWeight.Medium else FontWeight.Normal,
                letterSpacing = (-0.23).sp,
                textAlign = TextAlign.End
            ),
            modifier = Modifier.weight(1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun VenueScheduleCurrentStatus(status: WorkStatus) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .height(54.47.dp)
            .clip(RoundedCornerShape(12.dp))
            .background(if (status.isOpen) StatusActiveBg else MineShaft50)
            .padding(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = if (status.isOpen) "Зараз відчинено" else "Зараз зачинено",
            style = BodyMedium.copy(
                color = if (status.isOpen) ActiveStatusColor else MineShaft600,
                fontSize = 15.sp,
                lineHeight = 22.5.sp,
                fontWeight = FontWeight.Medium,
                letterSpacing = (-0.23).sp
            ),
            modifier = Modifier.weight(1f),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )

        val secondaryTime = if (status.isOpen) status.closeTime else status.nextOpenTime
        if (secondaryTime != null) {
            Text(
                text = if (status.isOpen) {
                    stringResource(Res.string.client_venue_status_closes_at, secondaryTime.formatTime())
                } else {
                    "Відкривається о ${secondaryTime.formatTime()}"
                },
                style = BodyMedium.copy(
                    color = MineShaft600,
                    fontSize = 14.sp,
                    lineHeight = 21.sp,
                    fontWeight = FontWeight.Normal,
                    letterSpacing = (-0.15).sp,
                    textAlign = TextAlign.End
                ),
                modifier = Modifier.weight(1f),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
}

private fun WorkDay.scheduleText(): String {
    if (!isOpen) return "Зачинено"
    val open = openTime ?: return "Відчинено"
    val close = closeTime ?: return open.formatTime()
    return "${open.formatTime()} - ${close.formatTime()}"
}

private fun VenueDayOfWeek.label(): String {
    return when (this) {
        VenueDayOfWeek.MONDAY -> "Понеділок"
        VenueDayOfWeek.TUESDAY -> "Вівторок"
        VenueDayOfWeek.WEDNESDAY -> "Середа"
        VenueDayOfWeek.THURSDAY -> "Четвер"
        VenueDayOfWeek.FRIDAY -> "П'ятниця"
        VenueDayOfWeek.SATURDAY -> "Субота"
        VenueDayOfWeek.SUNDAY -> "Неділя"
    }
}

private fun VenueDayOfWeek.sortIndex(): Int {
    return VenueDays.indexOf(this)
}

private fun VenueDayOfWeek.plusDays(days: Int): VenueDayOfWeek {
    val index = (sortIndex() + days) % VenueDays.size
    return VenueDays[index]
}

private fun List<WorkDay>.nextOpenTimeFrom(currentDay: VenueDayOfWeek, currentTime: LocalTime): LocalTime? {
    val currentMinutes = currentTime.minutesOfDay()
    for (offset in 0 until VenueDays.size) {
        val day = currentDay.plusDays(offset)
        val workDay = firstOrNull { it.day == day }
        val openTime = workDay?.openTime
        if (workDay?.isOpen != true || openTime == null) continue

        if (offset > 0 || openTime.minutesOfDay() > currentMinutes) {
            return openTime
        }
    }

    return null
}

private val VenueDays = listOf(
    VenueDayOfWeek.MONDAY,
    VenueDayOfWeek.TUESDAY,
    VenueDayOfWeek.WEDNESDAY,
    VenueDayOfWeek.THURSDAY,
    VenueDayOfWeek.FRIDAY,
    VenueDayOfWeek.SATURDAY,
    VenueDayOfWeek.SUNDAY
)

private data class WorkStatus(
    val isOpen: Boolean,
    val closeTime: LocalTime?,
    val nextOpenTime: LocalTime?
)

private fun VenueResponse.currentWorkStatus(): WorkStatus {
    val now = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault())
    val day = now.date.dayOfWeek.toVenueDayOfWeek()
    val workDay = schedule.workDays.firstOrNull { it.day == day }
        ?: return WorkStatus(false, null, schedule.workDays.nextOpenTimeFrom(day, now.time))
    if (!workDay.isOpen) {
        return WorkStatus(false, null, schedule.workDays.nextOpenTimeFrom(day, now.time))
    }

    val openTime = workDay.openTime
    val closeTime = workDay.closeTime
    if (openTime == null || closeTime == null) return WorkStatus(true, closeTime, null)

    val nowMinutes = now.time.minutesOfDay()
    val openMinutes = openTime.minutesOfDay()
    val closeMinutes = closeTime.minutesOfDay()
    val isOpen = if (closeMinutes >= openMinutes) {
        nowMinutes in openMinutes..closeMinutes
    } else {
        nowMinutes >= openMinutes || nowMinutes <= closeMinutes
    }

    return WorkStatus(
        isOpen = isOpen,
        closeTime = closeTime.takeIf { isOpen },
        nextOpenTime = if (isOpen) null else schedule.workDays.nextOpenTimeFrom(day, now.time)
    )
}

@Suppress("REDUNDANT_ELSE_IN_WHEN")
private fun kotlinx.datetime.DayOfWeek.toVenueDayOfWeek(): VenueDayOfWeek = when (this) {
    kotlinx.datetime.DayOfWeek.MONDAY -> VenueDayOfWeek.MONDAY
    kotlinx.datetime.DayOfWeek.TUESDAY -> VenueDayOfWeek.TUESDAY
    kotlinx.datetime.DayOfWeek.WEDNESDAY -> VenueDayOfWeek.WEDNESDAY
    kotlinx.datetime.DayOfWeek.THURSDAY -> VenueDayOfWeek.THURSDAY
    kotlinx.datetime.DayOfWeek.FRIDAY -> VenueDayOfWeek.FRIDAY
    kotlinx.datetime.DayOfWeek.SATURDAY -> VenueDayOfWeek.SATURDAY
    kotlinx.datetime.DayOfWeek.SUNDAY -> VenueDayOfWeek.SUNDAY
    else -> VenueDayOfWeek.MONDAY
}

private fun LocalTime.minutesOfDay(): Int = hour * 60 + minute

private fun LocalTime.formatTime(): String {
    return "${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}"
}

private fun String.withHttpScheme(): String {
    return if (startsWith("http://") || startsWith("https://")) this else "https://$this"
}

private fun String.filterPhoneForUri(): String {
    return filter { it.isDigit() || it == '+' }
}

private fun VenueResponse.shareMessage(): String {
    return buildList {
        add(name)
        location.address.takeIf(String::isNotBlank)?.let(::add)
        add(clientVenueDeepLink(id))
    }.joinToString(separator = "\n")
}

private val ActiveStatusColor = Color(0xFF007A55)
private val OwnerUnauthorizedColor = Color(0xFF956744)
private val OwnerAuthorizedColor = Color(0xFF007A55)
